module.exports = __webpack_public_path__ + "static/prediction-04dfbfde52e7706f6aba8db6afe46637.png";